import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "Finance"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M1.5 20.9999H22.5V22.4999H1.5V20.9999ZM20.25 8.24993C20.6642 8.24993 21 7.91414 21 7.49993V5.24993C20.9999 4.93415 20.802 4.65229 20.505 4.54493L12.255 1.54493C12.0902 1.48535 11.9098 1.48535 11.745 1.54493L3.495 4.54493C3.19804 4.65229 3.00013 4.93415 3 5.24993V7.49993C3 7.91414 3.33579 8.24993 3.75 8.24993H4.5V17.9999H3V19.4999H21V17.9999H19.5V8.24993H20.25ZM4.5 5.77493L12 3.04493L19.5 5.77493V6.74993H4.5V5.77493ZM13.5 17.9999H10.5V8.24994H13.5V17.9999ZM6 8.24994H9V17.9999H6V8.24994ZM18 17.9999H15V8.24994H18V17.9999Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/Finance.vue"]]);
